export default __webpack_public_path__ + "640231496f898b8fbe0cb01d06ec8400.png";